<div class="wrapper box-container">
    <p class="body-2">Powered by Rymax Inc. © 2023-{{ currentYear }}.</p>
    <p class="links">
        <a class="body-1 underline" [routerLink]="privacyPolicyPath">Privacy Policy</a>

        <a class="body-1 underline" [routerLink]="termsAndConditionsPath">Terms of Use</a>
    </p>
</div>
